import { render } from "./MenuItemCategory.vue?vue&type=template&id=39623d1c&scoped=true"
import script from "./MenuItemCategory.vue?vue&type=script&lang=js"
export * from "./MenuItemCategory.vue?vue&type=script&lang=js"

import "./MenuItemCategory.vue?vue&type=style&index=0&id=39623d1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39623d1c"]])

export default __exports__